import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "close",
  "use": "close-usage",
  "viewBox": "0 0 25 25",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25 25\" id=\"close\">\r\n  <path d=\"M22,.71a1.9,1.9,0,0,1,2.64-.3,1.9,1.9,0,0,1-.3,2.64h0L14.84,12.5,24.29,22a2,2,0,0,1,.4,2.54l-.1.1a1.9,1.9,0,0,1-2.64-.3h0L12.5,14.84,3.05,24.29a2,2,0,0,1-2.54.4l-.1-.1A1.9,1.9,0,0,1,.71,22h0l9.45-9.45L.71,3.05A2,2,0,0,1,.31.51l.1-.1a1.9,1.9,0,0,1,2.64.3h0l9.45,9.45Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol